/**
 * Created by moort on 1/11/19.
 */
import React, { Component } from 'react';
const speakers = {
    rajivAmar:{
        speakerAvatar:"rajivAmar",
        speakerName:"Rajiv Amar",
        speakerTitle:"Global CTO, CDK Global",
        speakerBio:(<span>
            Senior executive and technology change leader who converts vision into innovative solutions. Enabling Automotive commerce and innovating within it!
        </span>),
        speakerLinkedIn:"https://www.linkedin.com/in/rajivamar/",
        speakerTwitter:"https://twitter.com/Rajiv_SD",
        speakerEmail:"Rajiv.Amar@cdk.com (Amar, Rajiv)",
    },
    sahas:{
        speakerAvatar:"sahas",
        speakerName:"Sahas Subramanian",
        speakerTitle:"Software/Enterprise Architecture, Fortellis | CDK Global",
        speakerBio:(
            <span>No-nonsense natural leader, prefer to be doing something rather than talking about something.
                                                    <br/><br/>
                                                    Collaborate with cross-organizational teams to develop system architecture and lead the implementation of architecture strategy to achieve multi-year Business & IT goals.
                                                    <br/><br/>
                                                    Practice lead by influence model, continuously collaborate with a selected group of Sr Engineers, UX SMEs, Product SMEs and Architects to evolve implementation, feedback loop on architecture/design, introduce standards, best practices, tooling consistency, frameworks for better productivity and efficiency.
                                                    <br/><br/>
                                                    Hands-on experience with #Javascript, #node.js, #reactjs, #elasticsearch, #googlecloudplatform
                                                    ,#aws along with necessary tools to deliver the product end-end, such as #docker, #kubernetes, #apigee, #appdynamics, #selenium #webdriver, #jmeter etc.
                                                    <br/><br/>
                                                    Strong believer of Lean principles, love and practice #ToyotaKata.
                                                    <br/><br/>
                                                    Latest achievement https://fortellis.io/ for CDK Global. Proud to be the Architect of the revolutionary platform for the Automotive Industry.
                                                    <br/><br/>
                                                    Opinions, comments, thoughts, likes/dislikes not necessarily related to my work or employer.
                                                    <br/><br/>
                                                    What's keeping me excited at work?
                                                    <br/><br/>
                                                    Practicing to be a well rounded Architect. Acting as a tour guide, leading engineers and team towards the same technical vision by story-telling, pair programming, listening to their opinions, help resolving conflicts and building trust with individuals to turn our architectural vision into reality.
                                                    <br/><br/>
                                                    Keep customer first philosophy and focus on delivering the experience not just the software.</span>
        ),
        speakerLinkedIn:"https://www.linkedin.com/in/sahaswaranamam/",
        speakerTwitter:"https://twitter.com/Sahaswaranamam",
        speakerEmail:"Sahas.Subramanian@cdk.com (Subramanian, Sahas)"
    },
    jaredJones:{
        speakerAvatar:"jaredJones",
        speakerName:"Jared Jones",
        speakerTitle:"Software Engineer, Fortellis | CDK Global",
        speakerBio:(<span>Inspired by the web to try and make cool new things everyday · <a href="https://danggoodcode.com" target="_blank">https://danggoodcode.com</a> </span>),
        speakerLinkedIn:"https://www.linkedin.com/in/jared-jones-376243105/",
        speakerTwitter:"https://twitter.com/danggoodcode",
        speakerEmail:"Jared.Jones@cdk.com (Jones, Jared)"
    },
    jasonBonifay:{
        speakerAvatar:"jasonBonifay",
        speakerName:"Jason Bonifay",
        speakerTitle:"Chief Technology Officer, AutoGravity",
        speakerBio:(
            <span>
                Jason Bonifay is the Chief Technology Officer of AutoGravity and a veteran industry leader who has been the driving force behind some of the most impactful technology in the automotive space. Bonifay started at AutoGravity as the Vice President of Engineering where he developed a clear technological vision for the company, expanding the capabilities of the engineering team. Prior to joining AutoGravity, Bonifay served as VP of Development for Product and Engineering at CDK Global, where he was responsible for engineering, product management, architecture and operations. Bonifay earned both his undergraduate and graduate degrees in Engineering from Auburn University.
            </span>
        ),
        speakerLinkedIn:"https://www.linkedin.com/in/jasonbonifay/",
        speakerTwitter:"https://twitter.com/jasonbonifay",
        speakerEmail:"jason.bonifay@autogravity.com (Bonifay, Jason)"
    },
    julianBirkett:{
        speakerAvatar:"julianBirkett",
        speakerName:"Julian Birkett",
        speakerTitle:"Enterprise Architect, Fortellis | CDK Global",
        speakerBio:(
            <span>
                        I have worked in many parts of the technical side of enterprise level software including support, development and architecture as well as taking managerial roles in this space. I've been involved mainly with the Automotive industry but have also worked on recruitment software too.
                        <br/><br/>
                        I've been a major contributor in the development and design of 2 major new releases of software to run Automotive Dealerships. These products were close to ground up re-writes of the software and they are both still very successfully running car dealerships around the world. I've gained experience in Accounting, CRM, Point of Sale, Stock Control and Vehicle Sales (i.e. ERP) products which I've spent most of my working life dealing with. I've, therefore, been involved in the full software application life cycle from conception, through maintenance to end of life.
                        <br/><br/>
                        I have been a founder of an unsuccessful startup. This was a very interesting time for me as being responsible for people getting paid as well as trying to build a business is difficult. Whilst this was ultimately a failure, it did change my approach to business and made me more customer focused. It was also the reason I took an MBA because I wanted to understand about other aspects of a company, not just the development side.
                        <br/><br/>
                        Currently I'm working as an Enterprise Architect where I'm responsible for building a new API gateway and helping the company move from legacy applications to a more service orientated architecture. I also own the Vehicle Sales domain and work with teams around the world to move to help them move to our next generation platform. I've been responsible for selecting technology partners to enable the business requirements. I'm passionate about building the best products to help run an enterprise with the right technology for its use case with automation. I've worked a lot with implementing and using AWS, Node.js, JavaScript, Apigee, the Atlassian stack as well as our own proprietary technologies.
                    </span>
        ),
        speakerLinkedIn:"https://www.linkedin.com/in/julian-birkett-0a0302156/",
        speakerTwitter:"",
        speakerEmail:"julian.birkett@cdk.com (Birkett, Julian)"
    },
    kamilRodoper:{
        speakerAvatar:"kamilRodoper",
        speakerName:"Kamil B. Rodoper",
        speakerTitle:"Dir. Product Development, Lyft",
        speakerBio:(
            <span>
                As the Head of Lyft Business Products, Kamil oversees the product strategy and management for the transportation solutions that enable Lyft’s growth and expansion in various industries and verticals. His team assesses market opportunities in healthcare, corporate travel, transit and education, understands the passenger needs and builds solutions to establish Lyft as the preferred transportation solution provider for organizations in those industries.
                <br/><br/>
                Prior to Lyft, as Senior Director, Kamil led the product and monetization strategy at Glassdoor. During his four years at Glassdoor, he built the product and the engineering teams for jobs search, online marketplace, advertising platform and sales technology while growing the B2B revenue by 20X from 2013 to 2016. Previously, at Microsoft, he owned new search products and pricing at Bing Advertising and shipped Service Packs for Windows Server and Windows Vista. Kamil received his Bachelor’s degree in Electrical Engineering and holds a graduate degree in Image and Video Processing from Rensselaer Polytechnic Institute of New York.
            </span>
        ),
        speakerLinkedIn:"https://www.linkedin.com/in/kbrodoper/",
        speakerTwitter:"",
        speakerEmail:"krodoper@lyft.com (Rodoper, Kamil)"
    },
    carlosOrtiz:{
        speakerAvatar:"carlosOrtiz",
        speakerName:"Carlos Ortiz",
        speakerTitle:"Solution Architect, Google",
        speakerBio:(
            <span>
                        A highly experienced solution architect and technologist of internet, cloud, and enterprise software. Proven experience in leading complex technical sales and solution development that require advanced levels of business and technical acumen.
                        <br/><br/>
                        20 years’ experience with evaluating, implementing, and selling enterprise technology focused on cloud, full Web stack, and integration.<br/>
                        Technical lead on several multi-million in license sales throughout sales engineer career involving both point solutions and/or complete cross-stack sales.<br/>
                        Self-starter type. Technical know-how from hands on coding to complex configurations to deliver compelling customized demonstrations, proof-of-concepts, prototypes and white board discussions. Proven experience and success in both startup and big enterprise environments.<br/>
                        Down to earth communication/presentation style with familiarity and training in various sales and presentations techniques such as Miller Heiman, Presenting-to-Win, Info-Mentis, and Demo-to-Win.
                    </span>
        ),
        speakerLinkedIn:"https://www.linkedin.com/in/carlos-ortiz-29069b/",
        speakerTwitter:"",
        speakerEmail:"gcortiz@google.com"
    },
    vinitMehta:{

        speakerAvatar:"vinitMehta",
        speakerName:"Vinit Mehta",
        speakerTitle:"Sales Engineering GCP, Google",
        speakerBio:null,
        speakerLinkedIn:"https://www.linkedin.com/in/vinit-mehta-15ba296/",
        speakerTwitter:"",
        speakerEmail:"vinitmehta@google.com"
    },
    svenEidissen:{
        speakerAvatar:"sven",
        speakerName:"Sven Eidissen",
        speakerTitle:"Product Security Architect, Fortellis | CDK Global",
        speakerBio:(<span>Experienced Security Architect. Extensive experience in Enterprise Security Architecture and Solutioning, Agile Development Security, Penetration Testing, and Risk Management.</span>),
        speakerLinkedIn:"https://www.linkedin.com/in/sveinungeidissen",
        speakerTwitter:"https://twitter.com/sveiae",
        speakerEmail:"Sven.Eidissen@cdk.com (Eidissen, Sven)"
    },
    danielNew:{
        speakerAvatar:"danielNew",
        speakerName:"Daniel New",
        speakerTitle:"Enterprise Architect, CDK Global",
        speakerBio:null,
        speakerLinkedIn:"https://www.linkedin.com/in/daniel-new-145bb949/",
        speakerTwitter:"",
        speakerEmail:"Daniel.New@cdk.com (New, Daniel)"
    },
    brandonBoyd:{
        speakerAvatar:"brandonBoyd",
        speakerName:"Brandon Boyd",
        speakerTitle:"Platform Marketer, CDK Global",
        speakerBio:(
            <span>
               Global Marketing Expert focused on: B2B Software Marketing Lead Generation Strategy Marketing Automation Content Marketing
            </span>
        ),
        speakerLinkedIn:"https://www.linkedin.com/in/brandoboyd/",
        speakerTwitter:"https://twitter.com/marcommadness",
        speakerEmail:"Brandon.Boyd@cdk.com (Boyd, Brandon)"
    },
    abramGoldshtein:{
        speakerAvatar:"abramGoldshtein",
        speakerName:"Abram Goldshtein",
        speakerTitle:"Dir, Development, Fortellis | CDK Global",
        speakerBio:(<span>
            Seasoned engineering leader who oversees the design, development and enablement of Fortellis API Adapters, Solution Interface Technology and Developer Advocate/Relations teams.
            <br/><br/>
            Prior to joining Fortellis, Abram served as a senior leader across multiple domains including – Technical Services, Global Infrastructure, Platform Engineering, Site Reliability and most recently Cloud Hosting Engineering.
        </span>),
        speakerLinkedIn:"https://www.linkedin.com/in/abram-dan-goldshtein-52144362/",
        speakerTwitter:"https://twitter.com/heyAbram",
        speakerEmail:"Daniel.New@cdk.com (Goldshtein, Abram)"
    }
};
export default speakers;